import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';

import { Observable, of } from 'rxjs';
import { InventoryLotDTO } from '../../inventory/models/inventory-lot';

export interface lotInventory {
  lotId?: number,
  handlingUnitMasterId?: number[],
  handlingUnitDetailId?: number[],
  quantity?: number,
  toLocationId?: number,
  toWarehouseId?: number,
  toRoomId?: number,
  reasonCodeId?: number,
  orderNumber?: string,

  // front-end only
  originalQuantity?: number
  packoutCode?: string
}

@Injectable({
  providedIn: 'root'
})
export class lotInventoryService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public lotInventoryAdd(lotInventoryObj: lotInventory): Observable<lotInventory> {
    return this.httpClient.post<lotInventory>(`${this.basePath}/api/inventory/ChangeByLot/add`, lotInventoryObj);
  }

  public lotInventoryRemove(lotInventoryObj: lotInventory): Observable<lotInventory> {
    return this.httpClient.post<lotInventory>(`${this.basePath}/api/inventory/ChangeByLot/remove`, lotInventoryObj);
  }

  public lotInventoryTransfer(lotInventoryObj: lotInventory): Observable<lotInventory> {
    return this.httpClient.post<lotInventory>(`${this.basePath}/api/inventory/ChangeByLot/move`, lotInventoryObj);
  }

  public lotInventoryAddToOrder(lotInventoryObj: lotInventory): Observable<lotInventory> {
    return this.httpClient.post<lotInventory>(`${this.basePath}/api/inventory/ChangeByLot/moveToOrder`, lotInventoryObj);
  }

  public getLotById(lotId: string): Observable<InventoryLotDTO> {
    return this.httpClient.get<InventoryLotDTO>(`${this.basePath}/api/inventory/lots/${lotId}`);
  }

}
